export default function browser() {
    if (navigator.userAgent.indexOf('Mac OS X') >= 0) {
        document.body.classList.add('browser_os__mac');
    } else {
        document.body.classList.add('browser_os__pc');
    }
}
